export const siteUrl = 'https://psvoiceovers.com';

export const seo = {
  title: 'Paul Seager — Utah Voice Over Artist | Commercials, Imaging, Promo & Narration',
  description:
    'Utah voice over artist Paul Seager: commercials, imaging, promo, and corporate narration. Broadcast-ready studio in South Jordan, most projects delivered within 24 hours, available worldwide via Source-Connect.',
  keywords: [
    'Paul Seager',
    'PS Voiceovers',
    'male voice over',
    'voice over talent',
    'voice over artist Utah',
    'Utah voice over',
    'South Jordan voice actor',
    'Salt Lake City voice over',
    'commercial voice over',
    'radio imaging voice',
    'promo voice actor',
    'corporate narration',
    'e-learning narrator',
    'IVR voice talent',
    'professional voice actor',
    'Source-Connect voice talent',
  ].join(', '),
  ogImage: `${siteUrl}/og-image.jpg`,
  locale: 'en_US',
  businessName: 'PS Voiceovers LLC',
  location: {
    city: 'South Jordan',
    region: 'UT',
    country: 'US',
    areaServed: ['Utah', 'United States', 'Worldwide'],
    geo: { latitude: 40.5622, longitude: -111.9297 },
  },
  profiles: [
    'https://www.voices.com/profile/paulseager',
    'https://voice123.com/voice-actor/paul82',
  ],
  services: [
    'Commercial Voice Over',
    'E-Learning Narration',
    'Imaging and Radio Voice Over',
    'IVR and Telephony',
    'Character Voices',
    'Corporate Narration',
  ],
};
